import { render, staticRenderFns } from "./utilities-notes.vue?vue&type=template&id=129edbeb"
import script from "./utilities-notes.vue?vue&type=script&lang=js"
export * from "./utilities-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports